module.exports = " <h2 class=text-center>Tu cuenta ha sido verificada, ya puedes iniciar sesión</h2> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Account-valid.vue
// module id = 569
// module chunks = 0